module.exports = __webpack_public_path__ + "img/NoData.fb87fa42.png";